import type { VisibleVoiceDisplayName } from '@listening/api-contract/schemas';
import { predefinedVoiceCatalog } from '@listening/frontend/query/voices';

/**
 * Portrait for one of our voices, taken from the shared voice catalog
 * (`VOICE_DEFS` → `/voice-images/<model_id>.webp`) — the same source the in-app
 * voice picker, the play-bar and mobile render.
 *
 * Importing hand-picked jpegs from `@listening/assets` instead would be a
 * second voice list that silently drifts from the product's art when a voice is
 * renamed, retired, or re-shot. `VisibleVoiceDisplayName` covers exactly the
 * catalog this looks up, so a typo, a retired voice or a newly hidden one is a
 * compile error at the call site and the runtime miss below is unreachable.
 */
export function voicePortrait(name: VisibleVoiceDisplayName): string {
  const voice = predefinedVoiceCatalog.find((entry) => entry.name === name);
  if (!voice) throw new Error(`Voice "${name}" is missing from the catalog`);
  return voice.image_url;
}
